const SVG_ROOT_PATH = "assets/svg/";
const PNG_ROOT_PATH = "assets/png/";
export const AppIconPaths = {
  PARAMOUNT_CP_CENTRAL_LOGO: `${SVG_ROOT_PATH}PARA_CP_Central_Logo_RGB_dark-bg-outline.svg`,
  PARAMOUNT_LOGO: `${SVG_ROOT_PATH}Paramount_Logo.svg`,
  BLANK_TILE: `${SVG_ROOT_PATH}Blank_Tile.svg`,
  USER_ICON: `${PNG_ROOT_PATH}user.png`,
};
